import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.addEventListener('turbo:frame-load', this.hideBackButton)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.hideBackButton)
  }

  open(event) {
    event.preventDefault()
    const frame = document.getElementById("turbo_modal_frame")
    const backButton = document.getElementById("back-button")
    if (backButton) backButton.style.display = "none"
    frame.innerHTML = `
      <div class="d-flex justify-content-center align-items-center" style="height:70vh;">
        <div class="circle-spinner-border">
        </div>
      </div>
    `
    Turbo.visit(this.element.href, { frame: "turbo_modal_frame" })
  }

  hideBackButton() {
    const backButton = document.getElementById("back-button")
    if (backButton) backButton.style.display = "none"
  }
}
